angular
	.module 'App.Module.CustomerDisplay', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY, SEARCH_CONFIGURATION) ->
		$stateProvider
			.state 'customer_display_media',
				url: '/icd_media',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					"entity_search@customer_display_media":
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Shared.Setting.InteractiveCustomerDisplayMedia.Enabled'
					searchParams:
						title: 'general.customer_display.media'
						advanced:
							configuration: SEARCH_CONFIGURATION.customer_display_media
						repositoryName: 'CustomerDisplayMediaRepository'

			.state 'customer_display_media.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					entity: (CustomerDisplayMediaRepository, $stateParams) ->
						query = CustomerDisplayMediaRepository.createQuery()
						query
							.with 'files'
							.withIds 'shops', 'shop_groups'

						return CustomerDisplayMediaRepository.getEntity $stateParams.id, query

					_shops: (ShopRepository, ConfigurationService, entity, $stateParams) ->
						if (
							_.isEmpty($stateParams.id) ||
							_.isEmpty(entity.shops) ||
							ConfigurationService.isEnabled('Backoffice.ShopManagement.Shops.EnableShopGroups')
						)
							return

						query = ShopRepository.getQuery()
						query.criteria 'id', 'IN', entity.shops.join()

						ShopRepository
							.getEntities(query)
							.then (shops) =>
								entity.shops = shops

					_shopGroups: (ShopGroupRepository, ConfigurationService, entity, $stateParams) ->
						if (
							_.isEmpty($stateParams.id) ||
							_.isEmpty(entity.shop_groups) ||
							ConfigurationService.isDisabled('Backoffice.ShopManagement.Shops.EnableShopGroups')
						)
							return

						query = ShopGroupRepository.getQuery()
						query.criteria 'id', 'IN', entity.shop_groups.join()

						ShopGroupRepository
							.getEntities(query)
							.then (shopGroups) =>
								entity.shop_groups = shopGroups

			.state 'customer_display_media.edit.details',
				url: '/edit',
				views:
					entity_sub_view:
						controller: 'CustomerDisplayMediaController'
						controllerAs: 'vm'
						templateUrl: '@app/customer-display-media/customer-display-media.view.html'
